import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import AttachmentTable from '../components/AttachmentTable/AttachmentTable';
import { fetchAttachments } from '../../../store/apis/expenseService';

export default function ViewAttachmentsModal({
  isOpen,
  toggle,
  claimNo,
  srNo,
  claimStatus,
  finCoCd,
}) {
  const { data: attachments, isLoading: attachmentsIsLoading } = useQuery({
    queryKey: ['expense-claim-view-attachments', claimNo, srNo],
    queryFn: () =>
      fetchAttachments({
        docType: 'DOC_TYPE_EXPENSE_CLAIM',
        claimNo: claimNo || '',
        docIndex: srNo,
        finCoCd: finCoCd || '',
      }),
    enabled: !!claimNo && !!srNo,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>View Attachments</ModalHeader>
      <hr className="mb-1" />
      <ModalBody className="upload-attachments-modal">
        <AttachmentTable
          claimNo={claimNo}
          claimStatus={claimStatus}
          attachments={attachments}
          queryKey="expense-claim-view-attachments"
          attachmentsIsLoading={attachmentsIsLoading}
          maxHeight="500px"
          finCoCd={finCoCd}
        />
      </ModalBody>
    </Modal>
  );
}
